import React from 'react'
import { createUseStyles } from 'react-jss'

const Header = ({
  backgroundcolor,
  img,
  title,
  body,
  buttonText,
  buttonURL,
  buttonText2,
  buttonURL2,
}) => {
  const useStyles = createUseStyles(theme => ({
    container: { padding: '30px 0' },
    innerCont: {
      boxSizing: 'border-box',
      margin: '0 auto',
      width: '100%',
      maxWidth: '1220px',
      padding: '62px 104px 62px 104px',
      backgroundColor: backgroundcolor,
      borderRadius: 30,
      display: 'grid',
      gridTemplateColumns: '5fr 4fr',
      alignItems: 'center',
      '@media (max-width: 600px)': {
        padding: '60px 20px',
        borderRadius: 0,
        gridTemplateColumns: '1fr',
      },
    },
    title: {
      fontSize: '26px',
      lineHeight: '30px',
      fontWeight: 700,
      fontFamily: 'TTRounds',
      textAlign: 'left',
      marginBottom: '20px',
      marginTop: 0,
      color: '#2D2D2D',
      '@media (max-width: 600px)': {
        fontSize: '28px',
        lineHeight: '32px',
        marginBottom: '10px',
        paddingRight: 70,
      },
    },
    details: {
      color: '#2D2D2D',
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: 400,
      fontFamily: 'TTRounds',
      textAlign: 'left',
      marginBottom: '54px',
      marginTop: 0,
      '@media (max-width: 600px)': {
        fontSize: '15px',
        lineHeight: '22px',
      },
    },
    texts: {},
    imgs: {
      paddingLeft: '104px',
      textAlign: 'center',
      '@media (max-width: 600px)': {
        paddingLeft: '0',
        display: 'none',
      },
    },
    buttons: {
      '& a': {
        backgroundColor: theme.colors.orange,
        color: theme.colors.white,
        borderRadius: 15,
        display: 'inline-block',
        padding: '14px 10px',
        width: 220,
        fontSize: 15,
        textAlign: 'center',
        textDecoration: 'none',
        '@media (max-width: 600px)': {
          fontSize: 18,
          width: 'auto',
          display: 'block',
        },
        '&:hover': {
          backgroundColor: theme.colors.orangeHover,
          textDecoration: 'none',
        },
        '&:first-child': {
          marginRight: 20,
          '@media (max-width: 600px)': {
            marginRight: 0,
            marginBottom: 24,
          },
        },
      },
    },
    titleSec: {
      '@media (max-width: 600px)': {
        display: 'flex',
        alignItems: 'flex-end',
        marginBottom: 30,
      },
    },
    titleimg: {
      '@media (min-width: 600px)': {
        display: 'none',
      },
    },
  }))

  const classes = useStyles()

  return (
    <div className={classes.container}>
      <div className={classes.innerCont}>
        <div className={classes.texts}>
          <div className={classes.titleSec}>
            <div className={classes.title}>{title}</div>
            <div className={classes.titleimg}>
              <img src={img} alt={title} width={101} height={74} />
            </div>
          </div>
          <div className={classes.details} dangerouslySetInnerHTML={{ __html: body }} />
          {(buttonText || buttonText2) && (
            <div className={classes.buttons}>
              {buttonText && <a href={buttonURL}>{buttonText}</a>}
              {buttonText2 && <a href={buttonURL2}>{buttonText2}</a>}
            </div>
          )}
        </div>
        <div className={classes.imgs}>
          <img src={img} alt={title} />
        </div>
      </div>
    </div>
  )
}

Header.defaultProps = {}

export default Header
